export const SOCIAL_MEDIA_TYPES = [
	{ type: 'twitter', key: 'twitterHandle' },
	{ type: 'linkedIn', key: 'linkedInHandle' },
	{ type: 'crunchbase', key: 'crunchbaseHandle' },
	{ type: 'facebook', key: 'facebookHandle' },
];
